module.exports = __webpack_public_path__ + "media/16.ab60c980.mp3";